import { FeedFilters, FeedResponse } from "../types/feed";
import { apiUrl } from "./api";

export interface FetchFeedParams extends FeedFilters {
  limit?: number;
  cursor?: string | null;
  since?: string;
}

export const DEFAULT_PAGE_SIZE = 50;

export async function fetchFeed(params: FetchFeedParams = {}): Promise<FeedResponse> {
  const url = apiUrl("/feed");
  const query = new URLSearchParams();

  if (params.pilot) {
    query.set("pilot", params.pilot);
  }

  if (params.pilot_uid) {
    query.set("pilot_uid", params.pilot_uid);
  }

  if (params.actor_uid) {
    query.set("actor_uid", params.actor_uid);
  }

  if (params.server_id) {
    query.set("server_id", params.server_id);
  }

  if (params.server_name) {
    query.set("server_name", params.server_name);
  }

  if (params.unit_type) {
    query.set("unit_type", params.unit_type);
  }

  if (params.weapon) {
    query.set("weapon", params.weapon);
  }

  if (params.airdrome) {
    query.set("airdrome", params.airdrome);
  }

  if (params.event_type) {
    query.set("event_type", params.event_type);
  }

  if (params.kind) {
    query.set("kind", params.kind);
  }

  query.set("limit", String(params.limit ?? DEFAULT_PAGE_SIZE));

  if (params.since) {
    query.set("since", params.since);
  }

  if (params.cursor) {
    query.set("cursor", params.cursor);
  }

  url.search = query.toString();

  const response = await fetch(url.toString());

  if (!response.ok) {
    const message = await extractErrorMessage(response);
    throw new Error(message);
  }

  const json = (await response.json()) as FeedResponse;
  return json;
}

async function extractErrorMessage(response: Response): Promise<string> {
  try {
    const data = await response.json();
    if (data && typeof data === "object" && "error" in data && typeof data.error === "string") {
      return data.error;
    }
  } catch (error) {
    // Fall through to generic message when JSON parsing fails.
  }

  return `Request failed with status ${response.status}`;
}
